"use strict";

import $ from 'jquery';
window.jQuery = window.$ = $;

import 'popper.js';
import 'bootstrap';
import 'slick-carousel';

import Cookies from '../../node_modules/js-cookie/src/js.cookie'
window.Cookies = Cookies;

import './components/no-js';
import './components/helpers';
import './components/cookie';
import './components/search';
import './components/loader';

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

$('.featured--2 .featured__items').slick();


// WEBPACK FOOTER //
// ./resources/js/index.js